/**
 * DPD province detection (QC vs ROC segmentation).
 *
 * Loaded only when the feature is on, the market is CA, we are not in the
 * theme editor, and Liquid could NOT already resolve the group (see
 * snippets/province-head.liquid). Everyone else — non-CA markets, logged-in
 * customers with a Canadian address, returning visitors with localStorage —
 * is handled server-side or by the inline head script, and never runs this.
 *
 * There is nothing to detect for Quebec: <html data-province-group="QC"> is
 * already the default. This file exists purely to DOWNGRADE QC -> ROC once the
 * IP lookup says the visitor is not in Quebec. Failing to detect therefore
 * fails safe (Quebec sees the smaller promo) — never the other way round.
 *
 * The visitor cannot change the result: there is no selector and no prompt.
 * Debug: ?dpd_debug=1 or localStorage 'dpd-debug' = '1'.
 */
(function () {
  'use strict';

  var cfg = window.DPDProvince;
  if (!cfg || !cfg.enabled || cfg.resolved || cfg.designMode || !cfg.isCanada) return;

  var KEY = 'dpd-province';
  var DEBUG = /[?&]dpd_debug=1/.test(location.search) || localStorage.getItem('dpd-debug') === '1';

  function log() {
    if (DEBUG) console.info.apply(console, ['[dpd-province]'].concat([].slice.call(arguments)));
  }

  function finish(group, code, source) {
    cfg.group = group;
    cfg.resolved = true;
    if (group === 'ROC') {
      // QC is the rendered default, so only ROC needs a DOM change.
      document.documentElement.setAttribute('data-province-group', 'ROC');
    }
    if (code) {
      // The full province code is persisted (not just the group) so a future
      // campaign can target any single province without a data migration.
      try {
        localStorage.setItem(KEY, JSON.stringify({
          code: code,
          group: group,
          source: source,
          timestamp: Date.now(),
        }));
      } catch (e) { /* private mode — detection just re-runs next page */ }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'province_detected', province: code, province_source: source });
    }
    log('resolved', { group: group, code: code, source: source });
    if (cfg._resolve) cfg._resolve(group);
  }

  function detect() {
    if (!window.LHGGeo) {
      log('LHGGeo missing — staying on the QC default');
      finish('QC', null, null);
      return;
    }

    window.LHGGeo.get(cfg.apiUrl).then(function (geo) {
      if (!geo || geo.country !== 'CA' || !geo.region) {
        // Worker down, or the IP resolves outside Canada (VPN / travelling).
        // We genuinely do not know the province: keep the safe QC default and
        // persist nothing, so the next page load tries again.
        log('unresolved, keeping QC default', geo);
        finish('QC', null, null);
        return;
      }
      var code = String(geo.region).toUpperCase();
      finish(code === 'QC' ? 'QC' : 'ROC', code, 'ip');
    });
  }

  detect();
})();
